<div class="flex flex-col h-screen overflow-hidden">

  <!-- Navbar -->
  <app-navbar />

  <!-- Content -->
  <div class="content-area flex-1 overflow-y-auto overflow-x-hidden">
    <router-outlet></router-outlet>
  </div>

</div>